import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";

const MenuSeparator = () => (
  <DropdownMenuPrimitive.Separator className="dropdown-menu-separator" />
);

export default MenuSeparator;
MenuSeparator.displayName = "DropdownMenuSeparator";
